// Field configuration for dynamic form rendering
export interface FieldConfig {
  name: string;
  label: string;
  type: "text" | "textarea" | "date" | "time" | "number" | "url";
  isRequired?: boolean;
  placeholder?: string;
  gridProps?: {
    xs?: number;
    md?: number;
  };
  inputProps?: {
    min?: number;
    max?: number;
    rows?: number;
    inputBoxSize?: "small" | "medium" | "large";
  };
}

export interface TabConfig {
  label: string;
  type: "system" | "promotion";
  fields: FieldConfig[];
}

// System Announcement Form Configuration
export const systemAnnouncementConfig: TabConfig = {
  label: "System Announcement with Image",
  type: "system",
  fields: [
    {
      name: "image_url",
      label: "Image URL",
      type: "text",
      isRequired: true,
      placeholder: "https://example.com/images/maintenance-notice.jpg",
      gridProps: { xs: 12 },
    },
    {
      name: "title",
      label: "Title",
      type: "text",
      isRequired: true,
      placeholder: "Enter title (e.g., Maintenance Scheduled)",
      gridProps: { xs: 12, md: 6 },
    },
    {
      name: "data.maintenance_date",
      label: "Maintenance Date",
      type: "date",
      isRequired: true,
      placeholder: "YYYY-MM-DD",
      gridProps: { xs: 12, md: 6 },
    },
    {
      name: "message",
      label: "Message",
      type: "textarea",
      isRequired: true,
      placeholder: "Enter message (e.g., We will be performing maintenance on Saturday from 2-4 AM. App may be unavailable during this time.)",
      gridProps: { xs: 12 },
      inputProps: { rows: 4 },
    },
    {
      name: "data.start_time",
      label: "Start Time",
      type: "time",
      isRequired: true,
      placeholder: "02:00",
      gridProps: { xs: 12, md: 6 },
      inputProps: { inputBoxSize: "medium" },
    },
    {
      name: "data.end_time",
      label: "End Time",
      type: "time",
      isRequired: true,
      placeholder: "04:00",
      gridProps: { xs: 12, md: 6 },
      inputProps: { inputBoxSize: "medium" },
    },
  ],
};

// Promotional Announcement Form Configuration
export const promotionalAnnouncementConfig: TabConfig = {
  label: "Promotional Announcement with Image",
  type: "promotion",
  fields: [
    {
      name: "image_url",
      label: "Image URL",
      type: "text",
      isRequired: false,
      placeholder: "https://example.com/images/promotion-banner.jpg",
      gridProps: { xs: 12 },
    },
    {
      name: "title",
      label: "Title",
      type: "text",
      isRequired: true,
      placeholder: "Enter title (e.g., Special Offer!)",
      gridProps: { xs: 12, md: 6 },
    },
    {
      name: "data.coupon_code",
      label: "Coupon Code",
      type: "text",
      isRequired: false,
      placeholder: "Enter coupon code (e.g., SAVE20)",
      gridProps: { xs: 12, md: 6 },
    },
    {
      name: "message",
      label: "Message",
      type: "textarea",
      isRequired: true,
      placeholder: "Enter message (e.g., Get 20% off on all orders today. Use code SAVE20)",
      gridProps: { xs: 12 },
      inputProps: { rows: 4 },
    },
    {
      name: "data.discount",
      label: "Discount",
      type: "number",
      isRequired: false,
      placeholder: "Enter discount percentage (e.g., 20)",
      gridProps: { xs: 12, md: 6 },
      inputProps: { min: 0, max: 100, inputBoxSize: "medium" },
    },
    {
      name: "data.url",
      label: "URL",
      type: "url",
      isRequired: false,
      placeholder: "https://app.example.com/offers",
      gridProps: { xs: 12, md: 6 },
    },
  ],
};

// All tab configurations
export const notificationTabsConfig: TabConfig[] = [
  systemAnnouncementConfig,
  promotionalAnnouncementConfig,
];

